var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.014.708a2 2 0 0 1 2.828 0l1.415 1.414a2 2 0 0 1 0 2.829L15.17 7.036l1.293 1.293a1 1 0 0 1-1.414 1.415L13.757 8.45l-7.33 7.329a3 3 0 0 1-1.532.82l-2.942.589a1 1 0 0 1-1.177-1.177l.588-2.942a3 3 0 0 1 .82-1.533l7.33-7.329-1.293-1.293A1 1 0 0 1 9.635 1.5l1.293 1.293L13.014.708Zm-2.086 4.914L3.6 12.952a1.002 1.002 0 0 0-.2.287l1.36 1.311a1 1 0 0 0 .254-.184l7.33-7.33-1.415-1.414Zm2.829 0-1.415-1.414 2.086-2.086 1.414 1.415-2.085 2.085Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpencil);
export default __webpack_public_path__ + "static/media/editpencil.dd605aa5231156ee78266372e792c9c7.svg";
export { ForwardRef as ReactComponent };